export default __webpack_public_path__ + "static/favicon-2da5afec7ce45284b081e708cb4416e9.ico";